import { useState } from "react";

export const useMilestoneActions = () => {
  const [isCompleting, setIsCompleting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleCompleting = (completing: boolean) => {
    setIsCompleting(completing);
  };

  const handleEditing = (editing: boolean) => {
    setIsEditing(editing);
  };

  return {
    isCompleting,
    handleCompleting,
    isEditing,
    handleEditing,
  };
};
